import Tooltip from "../../tooltip";
import FormSystemError from "../../../../utils/form-error-constants";

class ServiceContact {
    constructor() {
        this.formErrorConstants = new FormSystemError('#contactForm');
        this.formErrorConstants.init();
    }

    init() {
        let formSystemError = new FormSystemError();
        formSystemError.init();

        $("input[name='sex']").change(() => {
            this.removeErrorDiv($(".options.sex"));
        });

        $(".question").change(event => {
            this.removeErrorDiv(event.target);
        });

        this.sendEmail();
        this.showEmailSuccess();
    }

    sendEmail() {
        let tooltip = new Tooltip();
        tooltip.init();
        let form = $('#contactForm');

        form.on('click', '.check-form', {'form': form},  event => {
            let allowSendForm = true;
            event.preventDefault();
            let form = event.data.form;
            let recaptchaResponse = form.find('.recaptchaResponse');
            this.formErrorConstants.removeErrors(form);
            this.formErrorConstants.removeDataError(form);
            form.find('input:required, select:required').not(':button, :hidden').each(function (i, element) {
                let _element = $(element);
                let errorMessage = _element.data('error-message');
                if (errorMessage) {
                    let value = _element.val();
                    if (!value || value.length === 0) {
                        allowSendForm = false;
                        _element.attr('data-error', errorMessage);
                    }
                }
            });

            if (!$("input[name='sex']:checked").length) {
                allowSendForm = false;
                this.attachValidationMessage($(".options.sex"), this.formErrorConstants.constants.sex);
            }

            let questionArea = $(".question");
            if (!questionArea.val()) {
                allowSendForm = false;
                this.attachValidationMessage(questionArea, this.formErrorConstants.constants.question);
            }

            let questionMinLength = questionArea.attr("minlength");
            if (questionArea.val() && questionArea.val().length < questionMinLength) {
                allowSendForm = false;
                this.attachValidationMessage(questionArea, this.formErrorConstants.constants.question);
            }

            let email = $("input[name='email']");
            if (email.val() && !this.isEmail(email.val())) {
                allowSendForm = false;
                email.attr('data-error', 'email');
                this.formErrorConstants.init();
            }

            if (allowSendForm) {
                grecaptcha.execute(window.recaptchaSitekeyV3, { action: 'contactPage' }).then(function (token) {
                    recaptchaResponse.val(token);
                    form.submit();
                });
            } else {
                this.formErrorConstants.init();
            }
        });
    }

    isEmail(email) {
        let regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return regex.test(String(email).toLowerCase());
    }

    attachValidationMessage(element, message) {
        this.removeErrorDiv(element);
        element.after('<div class="notice notice-custom-error">' +
            '<div class="icon"><img src="/svg/icon-error.svg" alt=""></div>' +
            '<div class="text notice-error-text">' + message + '</div></div>');
    }

    removeErrorDiv(element) {
        let errorDiv = $(element).parent().find(".notice-custom-error");
        if (errorDiv.length) {
            errorDiv.remove();
        }
    }
    showEmailSuccess() {
        let result = this.getParameterByName('sent');
        if (result === '1') {
            $('.success-notice-email').show();
        }
    }

    getParameterByName(name) {
        let url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
}

$(document).ready(function () {
    let serviceContact = new ServiceContact();
    serviceContact.init();
});
